module.exports = __webpack_public_path__ + "static/media/figure-4a.1d8e3f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-4a.jpg
// module id = 1209
// module chunks = 0